import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  ALCOHOL_ADD_REQUEST,
  ALCOHOL_ADD_SUCCESS,
  ALCOHOL_ADD_FAILURE,
  ALCOHOL_EDIT_REQUEST,
  ALCOHOL_EDIT_SUCCESS,
  ALCOHOL_EDIT_FAILURE,
  ALCOHOL_VIEW_REQUEST,
  ALCOHOL_VIEW_SUCCESS,
  ALCOHOL_VIEW_FAILURE,
  ALCOHOL_VIEW_ALL_REQUEST,
  ALCOHOL_VIEW_ALL_SUCCESS,
  ALCOHOL_VIEW_ALL_FAILURE,
  ALCOHOL_DELETE_REQUEST,
  ALCOHOL_DELETE_SUCCESS,
  ALCOHOL_DELETE_FAILURE,
  ALCOHOL_RESET_STATE,
  ALCOHOL_SEARCH_REQUEST,
  ALCOHOL_SEARCH_SUCCESS,
  ALCOHOL_SEARCH_FAILURE,
  ALCOHOL_PERCENTAGE_VIEW_REQUEST,
  ALCOHOL_PERCENTAGE_VIEW_SUCCESS,
  ALCOHOL_PERCENTAGE_VIEW_FAILURE,
  WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_REQUEST,
  WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_SUCCESS,
  WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_FAILURE,
} from "./TypeOfAlcoholTypes";

const initialState = {
  addAlcohol: { ...defaultStatus },
  editAlcohol: { ...defaultStatus },
  deleteAlcohol: { ...defaultStatus },
  viewAlcohol: { ...defaultStatus },
  viewAllAlcohols: { ...defaultStatus },
  viewAlcoholPercentage: { ...defaultStatus },
  viewWholesalerAlcoholPercentage: { ...defaultStatus },
  viewAllSearchAlcohols: { ...defaultStatus },
};

const AlcoholReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    // Alcohol Add
    case ALCOHOL_ADD_REQUEST:
      return {
        ...state,
        addAlcohol: { ...defaultStatus, inProgress: true, ...payload },
      };
    case ALCOHOL_ADD_SUCCESS:
      return {
        ...state,
        addAlcohol: { ...defaultStatus, success: true, ...payload },
      };
    case ALCOHOL_ADD_FAILURE:
      return {
        ...state,
        addAlcohol: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    // Alcohol Edit
    case ALCOHOL_EDIT_REQUEST:
      return {
        ...state,
        editAlcohol: { ...defaultStatus, inProgress: true, ...payload },
      };
    case ALCOHOL_EDIT_SUCCESS:
      return {
        ...state,
        editAlcohol: { ...defaultStatus, success: true, ...payload },
      };
    case ALCOHOL_EDIT_FAILURE:
      return {
        ...state,
        editAlcohol: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    // Alcohol View
    case ALCOHOL_VIEW_REQUEST:
      return {
        ...state,
        viewAlcohol: { ...defaultStatus, inProgress: true, ...payload },
      };
    case ALCOHOL_VIEW_SUCCESS:
      return {
        ...state,
        viewAlcohol: { ...defaultStatus, success: true, ...payload },
      };
    case ALCOHOL_VIEW_FAILURE:
      return {
        ...state,
        viewAlcohol: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    // Alcohol View All
    case ALCOHOL_VIEW_ALL_REQUEST:
      return {
        ...state,
        viewAllAlcohols: { ...defaultStatus, inProgress: true, ...payload },
      };
    case ALCOHOL_VIEW_ALL_SUCCESS:
      return {
        ...state,
        viewAllAlcohols: { ...defaultStatus, success: true, data: payload },
      };
    case ALCOHOL_VIEW_ALL_FAILURE:
      return {
        ...state,
        viewAllAlcohols: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    // Alcohol Percentage View
    case ALCOHOL_PERCENTAGE_VIEW_REQUEST:
      return {
        ...state,
        viewAlcoholPercentage: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case ALCOHOL_PERCENTAGE_VIEW_SUCCESS:
      return {
        ...state,
        viewAlcoholPercentage: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case ALCOHOL_PERCENTAGE_VIEW_FAILURE:
      return {
        ...state,
        viewAlcoholPercentage: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Wholesaler Alcohol Percentage View
    case WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_REQUEST:
      return {
        ...state,
        viewWholesalerAlcoholPercentage: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_SUCCESS:
      return {
        ...state,
        viewWholesalerAlcoholPercentage: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_FAILURE:
      return {
        ...state,
        viewWholesalerAlcoholPercentage: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    // Alcohol Search View All
    case ALCOHOL_SEARCH_REQUEST:
      return {
        ...state,
        viewAllSearchAlcohols: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case ALCOHOL_SEARCH_SUCCESS:
      return {
        ...state,
        viewAllSearchAlcohols: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case ALCOHOL_SEARCH_FAILURE:
      return {
        ...state,
        viewAllSearchAlcohols: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    // Alcohol Delete
    case ALCOHOL_DELETE_REQUEST:
      return {
        ...state,
        deleteAlcohol: { ...defaultStatus, inProgress: true, ...payload },
      };
    case ALCOHOL_DELETE_SUCCESS:
      return {
        ...state,
        deleteAlcohol: { ...defaultStatus, success: true, ...payload },
      };
    case ALCOHOL_DELETE_FAILURE:
      return {
        ...state,
        deleteAlcohol: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    // Reset Alcohol State
    case ALCOHOL_RESET_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default AlcoholReducer;
